import { FC } from 'react'
import { EmptyState } from '../../empty-state'
import { TokenGatedEmptyState } from '../primitives'

interface Props {
  onClick: () => void
  artistName: string
  title: string
}

export const SectionEmptyState: FC<Props> = ({ onClick, artistName, title }) => (
  <TokenGatedEmptyState.Container>
    <TokenGatedEmptyState.Root>
      <EmptyState.Icon />
      <EmptyState.Text>{title}</EmptyState.Text>
      <EmptyState.ButtonRow>
        <EmptyState.PrimaryButton onClick={onClick}>
          {`Collect ${artistName} Token`}
        </EmptyState.PrimaryButton>
      </EmptyState.ButtonRow>
    </TokenGatedEmptyState.Root>
  </TokenGatedEmptyState.Container>
)
